import React from "react";

import "./styles/index.css";
import Helper from "util/Helper";
import ServiceModuleHome from "./components/ServiceModuleHome";
import ServiceDashboard from "./components/ServiceDashboard";
import ServiceProviderDashboard from "./components/ServiceProviderDashboard";
import CreateService from "./components/CreateService";
import AssignedServiceProvider from "./components/AssignedServiceProvider";
import CreateServiceProvider from "./components/CreateServiceProvider";
import ServiceProviderActionScreen from "./components/ServiceProviderActionScreen";
import AvailabilityCalendar from "./helper/AvailabilityCalendar";
import AssignChildServices from "./components/AssignChildServices";

class ServiceModule extends React.Component {
  constructor(props) {
    super(props);
    this.helper = new Helper();
    const searchParams = new URLSearchParams(props.location.search);

    const qpView = Number(searchParams.get("view"));
    const qpMode = searchParams.get("mode");
    const serviceId = searchParams.get("serviceId");
    const serviceProviderId = searchParams.get("serviceProviderId");

    this.state = {
      view: qpView || 0,
      props:
        qpMode && serviceId
          ? {
              mode: qpMode,
              serviceId: serviceId,
            }
          : qpMode && serviceProviderId
            ? {
                mode: qpMode,
                serviceProviderId: serviceProviderId,
              }
            : null,
      dashboardKeyService: 0,
      dashboardKeyServiceProvider: 0,
    };
  }

  setView = (v, p) => {
    this.setState({ view: v, props: p });
  };
  resetDashboardService = () => {
    this.setState((prev) => ({
      dashboardKeyService: prev.dashboardKeyService + 1,
    }));
  };
  resetDashboardServiceProvider = () => {
    this.setState((prev) => ({
      dashboardKeyServiceProvider: prev.dashboardKeyServiceProvider + 1,
    }));
  };

  render() {
    return (
      <>
        <div style={{ display: this.state.view === 1 ? "block" : "none" }}>
          <ServiceDashboard
            key={this.state.dashboardKeyService}
            setView={this.setView}
            data={this.state.props}
            resetDashboardService={this.resetDashboardService}
          />
        </div>
        <div style={{ display: this.state.view === 4 ? "block" : "none" }}>
          <ServiceProviderDashboard
            key={this.state.dashboardKeyServiceProvider}
            setView={this.setView}
            data={this.state.props}
            resetDashboardServiceProvider={this.resetDashboardServiceProvider}
          />
        </div>
        {this.state.view === 0 ? (
          <ServiceModuleHome setView={this.setView} data={this.state.props} />
        ) : this.state.view === 2 ? (
          <CreateService
            setView={this.setView}
            data={this.state.props}
            resetDashboardService={this.resetDashboardService}
          />
        ) : this.state.view === 3 ? (
          <AssignedServiceProvider
            setView={this.setView}
            data={this.state.props}
          />
        ) : this.state.view === 5 ? (
          <CreateServiceProvider
            setView={this.setView}
            data={this.state.props}
            resetDashboardServiceProvider={this.resetDashboardServiceProvider}
          />
        ) : this.state.view === 6 ? (
          <ServiceProviderActionScreen
            setView={this.setView}
            data={this.state.props}
          />
        ) : this.state.view === 7 ? (
          <AssignChildServices setView={this.setView} data={this.state.props} />
        ) : (
          <></>
        )}
      </>
    );
  }
}

export default ServiceModule;
